import React, { useEffect, useRef, useState } from 'react';
import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { useSelector } from "react-redux";
import moment from "moment";
import { postFormulaire } from "../../../api/envoiMailService";
import { checkInvalidDateEffet, renderError } from "../../../utils/formUtils";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";
import { getLabelInput } from "../../../utils/stringUtils";
const CONF = window?.confPub;

export default function ChangementNumSecuriteSociale(
    {
        isInside
    }
) {

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const PATTERNS = CONF?.PATTERNS
    const UI_DATE_EFFET = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.DATE_EFFET
    const UI_ATTESTATION_NIR =  CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.ATTESTATION_NIR
    const [disabledForm, setDisabledForm] = useState(false);
    const [submitted, setSubmitted] = useState(false)
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })

    const [idBeneficiaireSelected, setIdBeneficiaireSelected]= useState()
    const [attestationNir, setAttestationNir] = useState()
    const attestationNirRef = useRef(null)
    const [dateEffet, setDateEffet] = useState({
        name: UI_DATE_EFFET?.NAME,
        value: "",
        invalid: UI_DATE_EFFET?.ERRORS?.MANDATORY,
    })

    const handleOptionChange = (e) => {

        setIdBeneficiaireSelected(e?.target?.value)
    }

    const handleFileChange = (e) => {

        setAttestationNir(e.target.files[0]);
    }

    const handleDateEffet = (e) => {

        const value = e?.target.value

        dateEffetValidation(value)
    }

    const dateEffetValidation = (value) => {
        const invalid = checkInvalidDateEffet(value, PATTERNS?.YYYY_DASH_MM_DASH_DD)

        setDateEffet((prev) => ({
            ...prev,
            value: value,
            invalid: invalid,
        }))

        return invalid
    }

    const handleSubmit = async (e) => {

        e.preventDefault()
        setDisabledForm(true)

        const invalidDate = dateEffetValidation(dateEffet?.value)

        if (idBeneficiaireSelected && attestationNir && !invalidDate) {

            const contratBeneficiaire = contratsBeneficiaires.find(({ idUniqueGrc }) => idUniqueGrc === idBeneficiaireSelected)

            let formData = new FormData();
            formData.append("idGrm", keycloakReduce?.decodedToken?.idGrm)
            formData.append("emailCorrespondant", keycloakReduce?.decodedToken?.email)

            formData.append("numContratMp", detailPersonne?.contrat?.[0]?.numeroContrat)
            formData.append("nomMp", detailPersonne?.nom)
            formData.append("prenomMp", detailPersonne?.prenom)

            formData.append("nom", contratBeneficiaire?.nom)
            formData.append("prenom", contratBeneficiaire?.prenom)
            formData.append('dateNaissance', contratBeneficiaire?.dateNaissance)
            formData.append('dateEffet', moment(dateEffet?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY))
            formData.append('file', attestationNir)

            try {

                const resp = await postFormulaire(formData, CONF?.ROUTES?.ENVOI_MAIL?.CHANGEMENT_NIR)

                console.log("resp")
                console.log(resp)

                setSendSuccess({
                    isSuccess: true,
                    message: false,
                    display: true,
                })

                erasedInputs(false)

            } catch (err) {

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setSubmitted(true)

            } finally {

                // erasedInputs()
                setDisabledForm(false)
            }

        } else {
            setDisabledForm(false)
            setSubmitted(true)
        }
    }

    const erasedInputs = (all) => {


        setSubmitted(false)

        setDateEffet({
            value: "",
            invalid: UI_DATE_EFFET?.ERRORS?.MANDATORY,
        })

        setIdBeneficiaireSelected(null)
        setAttestationNir(null)

        if (attestationNirRef.current) {
            attestationNirRef.current.value = null
        }

        if (all) {
            setSendSuccess({
                isSuccess: false,
                message: false,
            })
        }
    }

    return (
        <div className="container mt-3">
            { !isInside && <SecondaryNavBar /> }
            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>
                    <div className="card">

                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>Changement de numéro de sécurité sociale</h2>
                            </div>

                            <div className="card-body">

                                <h3>Sélectionnez le bénéficiaire concerné :</h3>

                                { contratsBeneficiaires?.length > 0 && contratsBeneficiaires.map(contrat => (
                                    <div  key={ contrat?.idUniqueGrc }>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="contrat"
                                                value={ contrat?.idUniqueGrc }
                                                checked={ idBeneficiaireSelected === contrat?.idUniqueGrc }
                                                id={ contrat?.idUniqueGrc }
                                                onChange={ handleOptionChange }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ contrat?.idUniqueGrc }>
                                                { contrat?.civilite } { contrat?.prenom } { contrat?.nom }
                                            </label>

                                        </div>
                                        { submitted && !idBeneficiaireSelected
                                            && renderError("Vous devez sélectionner un bénéficiaire.") }
                                    </div>

                                )) }

                                <div className="mt-4 col-lg-4">
                                    <label
                                        htmlFor={ UI_DATE_EFFET?.NAME }>
                                        Date de prise d'effet
                                    </label>
                                    <input
                                        name={ UI_DATE_EFFET?.NAME }
                                        id={ UI_DATE_EFFET?.NAME }
                                        className="form-control"
                                        value={ dateEffet?.value }
                                        onChange={ handleDateEffet }
                                        type="date"/>

                                    { submitted && dateEffet?.invalid
                                        && renderError(dateEffet?.invalid) }
                                </div>

                                <div className="mt-4">
                                    <label
                                        htmlFor={ UI_ATTESTATION_NIR?.NAME }
                                        className="form-label">
                                        { getLabelInput(UI_ATTESTATION_NIR) }
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id={ UI_ATTESTATION_NIR?.NAME }
                                        name={ UI_ATTESTATION_NIR?.NAME }
                                        onChange={ handleFileChange }
                                        ref={ attestationNirRef }
                                    />
                                    { submitted && !attestationNir
                                        && renderError(UI_ATTESTATION_NIR?.ERRORS?.MANDATORY) }
                                </div>


                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />


                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                        // disabled={ !idBeneficiaireSelected || !dateEffet || !attestationNirRef?.current?.files[0] }
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        onClick={ ()  => erasedInputs(true)}
                                        className="btn btn-secondary ms-2"
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}